import type { SerializedConstructor } from '@langchain/core/load/serializable';

import { parseLangSmithParamsFromRun } from '@/utils/langsmith-params';

import type { ManifestPreviewProps } from '../../Manifest.utils';

export function useManifestAzureChatOpenAIModelAndProvider(
  props: ManifestPreviewProps<SerializedConstructor>
) {
  const id = props.value.id.at(-1) ?? '';
  const kwargs = props.value.kwargs;
  const deploymentName = kwargs.deployment_name ?? '';

  if (props.variant === 'line') {
    return {
      model: deploymentName,
      provider: id,
    };
  }
  return null;
}

export function inferAzureChatOpenAIManifestFromRun(
  params: ReturnType<typeof parseLangSmithParamsFromRun> | null,
  serializedModel: SerializedConstructor | null
): SerializedConstructor | null {
  if (
    params?.ls_provider !== 'azure' ||
    !(params?.ls_model_type == null || params.ls_model_type === 'chat')
  ) {
    return null;
  }

  return {
    lc: 1,
    type: 'constructor',
    id: ['langchain', 'chat_models', 'azure_openai', 'AzureChatOpenAI'],
    kwargs: {
      ...(params.ls_model_name !== undefined && {
        deployment_name: params.ls_model_name,
      }),
      ...(params.ls_temperature !== undefined && {
        temperature: params.ls_temperature,
      }),
      ...(params.ls_max_tokens !== undefined &&
        serializedModel?.kwargs.model_kwargs?.max_completion_tokens == null && {
          max_tokens: params.ls_max_tokens,
        }),
      ...(serializedModel?.kwargs.model_kwargs?.max_completion_tokens && {
        max_completion_tokens:
          serializedModel.kwargs.model_kwargs.max_completion_tokens,
        model_kwargs: Object.entries(
          serializedModel.kwargs.model_kwargs
        ).reduce((acc, [key, value]) => {
          if (key !== 'max_completion_tokens') {
            acc[key] = value;
          }
          return acc;
        }, {}),
      }),
    },
  };
}
